import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map, takeUntil } from 'rxjs/operators';

import { AbstractFilterModel } from '@gipi-pages/abstract/models/abstract-filter.model';
import { AbstractModel } from '@gipi-pages/abstract/models/abstract.model';
import { AbstractService } from '@gipi-pages/abstract/services/abstract.service';
import { StringUtil } from '@gipi-ui/utils/string.util';
import { DownloadBackupDTO } from '../models/download-backup.dto';

@Injectable({ providedIn: 'root' })
export class DownloadBackupService extends AbstractService<AbstractModel, AbstractFilterModel> {

    constructor(protected httpClient: HttpClient) {
        super('APOIO', 'backup', httpClient);
    }

    public downloadBackupFile(path: string): Observable<HttpResponse<Blob>> {
        if (StringUtil.isEmpty(path)) {
            throw new Error('O caminho do backup não foi informado');
        }
        return this.httpClient.get(this.url(`download-backup-file?filePath=${path}`), {
            ...this.options(),
            observe: 'response',
            responseType: 'blob'
        }).pipe(
            takeUntil(this.handleDestroy),
            catchError(this.handleError),
        );
    }

    public findBackupByCnpj(cpfOrCnpj: string): Observable<DownloadBackupDTO[]> {
        if (StringUtil.isEmpty(cpfOrCnpj)) {
            throw new Error('O CPF/CNPJ não foi informado');
        }
        return this.httpClient.get<DownloadBackupDTO[]>(this.url(`find-backup-by-cnpj/${cpfOrCnpj}`)).pipe(
            map(this.handleMapper),
            takeUntil(this.handleDestroy),
            catchError(this.handleError),
        );
    }

}

